// extracted by mini-css-extract-plugin
export default {"root":"FieldSeatsInput_root__k7GkY"};